import * as s from "components/Staking/StakeForEventPoints/Grid/Grid.styled";
import React from "react";

export function UnstakeButton(props: { onClick: () => void }) {
  return <s.YellowButton onClick={props.onClick}>Unstake</s.YellowButton>;
}
